import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate, isNullOrEmpty, enumText, showMessageToastCustom } from '../../../../../utils/util';
import { Breadcrumbs, ScannerCode, Input } from '../../../../../components/UI/ComponentsUI';
import * as actionsLinePicking from '../../../../../actions/linePickingAction';
import LinePickingService from '../../../../../services/LinePickingService';
import { ENUMS } from '../../../../../utils/constants';
import ConfirmModalFinalize from '../Mission/ConfirmModalFinalize';

const ReadQRCode = (props) => {
    const [qrCode, setQRCode] = useState("");
    const [groupUser, setGroupUser] = useState({});
    const [disable, setDisable] = useState(true);
    const getStatusGroup = (value) => translate(`expedition:${enumText(ENUMS.eOrderGroupStatus, value)}`);

    let messageModalFinalize;

    useEffect(() => {
        const inputFilter = document.getElementById('qrCodeFilter');
        if (inputFilter) {
            inputFilter.focus();
        }

        return () => {
            setGroupUser({});
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (groupUser?.orderGroupId > 0) {
            setDisable(false);
        } else {
            setDisable(isNullOrEmpty(qrCode));
        }
        // eslint-disable-next-line
    }, [qrCode, groupUser?.orderGroupId]);

    useEffect(() => {
        props.getGroupUser((item) => {
            setGroupUser(item || {});
        });
        // eslint-disable-next-line
    }, []);

    const scanner = (value) => {
        if (!isNullOrEmpty(value)) {
            setQRCode(value);
        }
    };

    const redirectPage = (addOrder) => {
        if (groupUser?.orderGroupId > 0 && !isNullOrEmpty(qrCode) && qrCode !== groupUser.inicialQrCode) {
            return showMessageToastCustom(translate('warning', 'general'), translate("QrCode-entered-differs", "general"), 8000, 'mdi mdi-alert-circle-outline red-text');
        }

        if (labelButtonFinalize() && !addOrder) {
            return messageModalFinalize.show();
        }

        if (groupUser?.orderGroupId > 0) {
            props.filter.orderGroupId = groupUser?.orderGroupId;
        }

        props.filter.inicialQrCode = qrCode;
        props.filter.dynamicFlow = props.location?.state.dynamicFlow;
        props.setFilterLinePicking(props.filter);
        props.history.replace({
            pathname: props.location?.state?.route,
            state: props.location?.state
        });
    };

    const subtitlesReadQRCode = () => {
        let subtitlesItems = [];
        if (props.location?.state?.subtitle) {
            subtitlesItems = [...subtitlesItems, { icon: props.location?.state?.subtitle?.icon, label: props.location?.state?.subtitle?.label }];
        }
        return subtitlesItems;
    }

    const labelButtonFinalize = () => {
        if (groupUser?.orderGroupId > 0 && groupUser?.status === ENUMS.eOrderGroupStatus.WaitingFinalQrCode.value) {
            return true;
        }
        return false;
    }

    const onFinalize = (qrcode, callback) => {
        props.finalize({ orderGroupId: groupUser?.orderGroupId, finalQrCode: qrcode }, () => {
            callback();
            setGroupUser({});
            setQRCode("");
        });
    }

    const addOrderGroup = () => {
        props.getNextOrder({ orderId: groupUser?.orders[0]?.orderId, areas: props.areas }, (response) => {
            if (response.data.success === 1) {
                redirectPage(true);
            }
        });
    }

    return (
        <>
            <Breadcrumbs id="idBreadcrumbs" subtitles={subtitlesReadQRCode()} />
            <div className="container-fluid" style={{ marginTop: '40px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '12px' }}>
                            <fieldset className='fieldset'>
                                <legend style={{ padding: '0 5px' }}>
                                    {
                                        props.location?.state?.icon ? (<i className={props.location?.state?.icon} />) : <i className='mdi mdi-qrcode' />
                                    }
                                    QR Code
                                </legend>
                                <div className="input-field no-padding col s12">
                                    <ScannerCode onScanner={scanner} />
                                    <Input
                                        id='qrCodeFilter'
                                        name='qrCodeFilter'
                                        type="text"
                                        required={props.location?.state?.required ? props.location?.state?.required : false}
                                        label={props.location?.state?.label ? props.location?.state?.label : translate("line-picking:linepicking.qrCode")}
                                        onChange={(event) => setQRCode(event.target?.value)}
                                        defaultValue={qrCode}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    {
                        groupUser?.orderGroupId > 0 && (
                            <div className="card">
                                <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '12px' }}>
                                    <fieldset style={{ border: '1px solid #597dda' }} onClick={() => setQRCode(groupUser.inicialQrCode)}>
                                        <legend style={{ padding: '0 5px' }}>
                                            {` Bloco ${groupUser.orderGroupId}`}
                                        </legend>
                                        <div className="input-field no-padding col s12">
                                            <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                                <span className="field f-1r">{groupUser.inicialQrCode}</span>
                                                <label className="active" htmlFor="productId">{translate('line-picking:linepicking.qrCode')}</label>
                                            </div>
                                            <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                                <span className="field f-1r">{groupUser.area}</span>
                                                <label className="active" htmlFor="productId">{translate('line-picking:linepicking.area')}</label>
                                            </div>
                                            <div className="input-field no-padding col s6 mb-8" style={{ marginRight: '0' }}>
                                                <span className="field f-1r">{getStatusGroup(groupUser.status)}</span>
                                                <label className="active" htmlFor="Bloco">{translate('line-picking:linepicking.status')}</label>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <ConfirmModalFinalize
                                    ref={((el) => messageModalFinalize = el)}
                                    dismissible={false}
                                    id="messageModalFinalize"
                                    groupOrder={groupUser}
                                    data={{ title: translate('validations:attention'), message: translate('line-picking:linepicking:confirm-order-finalize') }}
                                    onAdd={addOrderGroup}
                                    onFinalize={onFinalize}
                                    btnAdd={translate('general:add')}
                                    btnFinalize={translate('general:finalize')}
                                />
                            </div>
                        )
                    }
                    {
                        (!isNullOrEmpty(qrCode) || groupUser?.orderGroupId > 0) && (
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <button
                                    type="button"
                                    className="col s12 m3 btn btn-principal waves-effect waves-light"
                                    onClick={() => redirectPage(false)}
                                    style={{ width: '100%' }}
                                    disabled={disable}
                                >
                                    {labelButtonFinalize() ? 'Finalizar Bloco' : translate('apply', 'general')}
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter,
        areas: state.linePickingReducer.areas
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterLinePicking: (filter) => {
            dispatch(actionsLinePicking.setFilter(filter));
        },
        getGroupUser: (callback) => {
            dispatch(LinePickingService.getOrderGroupUser(callback));
        },
        finalize: (data, callback) => {
            dispatch(LinePickingService.finishOrderGroup(data, callback))
        },
        getNextOrder: (filter, callback) => {
            dispatch(LinePickingService.getNextOrder(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReadQRCode)));